export default __webpack_public_path__ + "static/media/Revolving Table.3e19af87.jpg";